export const BottomBarId = 'BottomBar';
